import  * as React from "react";
import { observer } from "mobx-react";
import { IOptimizerTilesParams } from "./IOptimizerTilesParams";
import { OptimizerSingleTile } from "./../OptimizerSingleTile/OptimizerSingleTile";

@observer
export class OptimizerTiles extends React.Component<IOptimizerTilesParams>{
    constructor(props: IOptimizerTilesParams) {
        super(props, undefined);
    }

    render() {
        return <div className="OptimizerTiles variable-and-optimal-variable-wrapper">
                   <div className="variable-and-optimal-variable-wrapper">
                       {this.props.optimizerHighlights &&
                           this.props.optimizerHighlights.map((highlight, i) => {
                               return <OptimizerSingleTile
                                   title={highlight.title}
                                   key={highlight.title}
                                          optimalValue={highlight.optimalValue}
                                          unit={highlight.unit}
                                          highlightValue={highlight.highlightValue}>
                                      </OptimizerSingleTile>;
                           })}
                   </div>
               </div>;
    }
}
